import moment from 'moment'

// ジョブコミ独自: 勤務開始日時(勤務日dt_1 + 開始時間dt_2)まで一定時間を切ったら
// mypageでの編集をエラーにするバリデーション。
// data-job-komi-time-keyで指定された開始時間フィールドと、自分自身の値(勤務日)から
// 勤務開始日時を組み立て、現在時刻からの残り時間を判定する。
// 求職者向けの応募締切(48時間, Customs::JobKomi.after_apply_period?)とは
// 目的・閾値が異なる別物のため、同じdt_1/dt_2を参照しつつ独立したルールとして実装している。

// toggle-form.js / job-komi-min-wage-validator.jsと同様、同じフォーム内の別フィールドを
// (nameのkey部分を置換して)キー名で参照する。form-validator.jsのfindFieldByKeyと同じ実装。
const findFieldByKey = (el, key) => {
  const form = $(el).closest('form')
  const name = $(el).attr('name')
  const targetName = name.replace(/\[(?!.*\[).*/, '[' + key + ']')
  return form.find('input[name="' + targetName + '"],select[name="' + targetName + '"]')
}

// 勤務開始まで何時間を切ったら編集不可とするか
const WORK_START_EDIT_DEADLINE_HOURS = 72

// hhmmフィールド(開始時間)の値は"2000-01-01THH:MM"というダミー日付+実時刻の形式
// (_form.html.slimのhhmm実装を参照)のため、時刻部分(HH:MM)のみを取り出す。
const extractTimePart = (hhmmVal) => {
  const parts = String(hhmmVal).split('T')
  return parts.length === 2 ? parts[1] : null
}

// form-validator.jsの'job_komi_work_start_deadline'ルールから呼び出されるバリデーション本体
export const validJobKomiWorkStartDeadline = (value, el) => {
  if ($(el).prop('disabled') || $(el).prop('readonly')) {
    // readonly(編集不可)のフィールドは本人が変更できないため、時間経過で新たに
    // 72時間を切ってもエラー扱いにしない(そのまま送信ブロックされ続けるのを防ぐ)
    return true
  }

  if (!value) {
    return true
  }

  const timeKey = $(el).data('job-komi-time-key')
  if (!timeKey) {
    return true
  }

  const timeVal = findFieldByKey(el, timeKey).val()
  if (!timeVal) {
    // 開始時間が未選択の間は判定不可(presenceルールで別途必須チェックされる)
    return true
  }
  const timePart = extractTimePart(timeVal)
  if (!timePart) {
    return true
  }

  const workStartAt = moment(`${value}T${timePart}`, 'YYYY-MM-DDTHH:mm')
  if (!workStartAt.isValid()) {
    return true
  }

  const deadline = workStartAt.clone().subtract(WORK_START_EDIT_DEADLINE_HOURS, 'hours')
  return moment().isBefore(deadline)
}

// フォーム内の開始時間フィールドが変更された時、対応する勤務日フィールドの
// 勤務開始日時バリデーションを再実行する。form-validator.jsのonChangeFieldから呼び出される。
export const retriggerJobKomiWorkStartDeadlineOnChange = (form, changedField) => {
  form.find('input[data-rules*="job_komi_work_start_deadline"]').each((i, dateEl) => {
    const $dateEl = $(dateEl)
    if (!$dateEl.val().length) {
      return
    }
    const timeKey = $dateEl.data('job-komi-time-key')
    if (!timeKey) {
      return
    }
    const timeEl = findFieldByKey(dateEl, timeKey)
    if (changedField.is(timeEl)) {
      $dateEl.trigger('change')
    }
  })
}
